<template>
  <div class="p-mypage_upload__file__btn" @drop.prevent="dropHandler" @dragover.prevent>
    <input type="file" :id="id" @change="change" name="skillsheets[]" :multiple="multiple">
    <label class="file__mask center">
      <span>
        <img src="/images/pc/skillsheet.png" alt=""><br>
        ファイルをドラックまたはクリックでファイルを追加<br>
        2048 KBまでのファイルをアップロードできます。<br>
      </span>
      <input type="button" :id="'mask-' + id" @click="select" class="file__name">
    </label>
  </div>
</template>

<script>
import Form from "@/utils/Form";

export default {
  props: {
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
    id: {
      type: String,
      default() {
        return `upload-${this._uid}`
      },
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    select() {
      $("#" + this.id).click();
    },
    change() {
      $("#mask-" + this.id).val($("#" + this.id).val());
      let names = [];
      for (var i = 0; i < $("#" + this.id).get(0).files.length; ++i) {
          names.push($("#" + this.id).get(0).files[i].name);
      }
      $("#mask-" + this.id).val(names.join(', '));
    },
    dropHandler(ev) {
      document.getElementById(this.id).files = ev.dataTransfer.files;
      this.change();
    }

  },
  mounted() {
  },
  computed: {
  },
  created() {
  },
}
</script>
